<template>
  <div>
    <!--    errors-->
    <div class="invalid-feedback d-block" v-for="error in errors" v-cloak>{{ error[0] }}</div>

    <!--    filter-->
    <div v-if="availableFilters.productTypes !== undefined || availableFilters.sizes !== undefined || availableFilters.withDate !== undefined" class="form-inline">
      <div class="mr-2 my-1">

        <Select2
          v-if="availableFilters.productTypes !== undefined && availableFilters.productTypes.length > 1"
          :select2-options="{ placeholder: $t('ProductTypes') }"
          name="product_type"
          style="width: 200px"
          :model-value="clientFilters.product_type"
          @update:model-value="updateFilter('product_type', $event)"
          :options="availableFilters.productTypes.map(type => ({ id: parseInt(type.id), text: type.name }))"
          v-cloak>
        </Select2>
      </div>

      <div class="mr-2 my-1">

        <Select2
          v-if="availableFilters.sizes !== undefined && availableFilters.sizes.length > 1"
          name="size"
          :select2-options="{ placeholder: $t('Sizes') }"
          style="width: 100px"
          :model-value="clientFilters.size"
          @update:model-value="updateFilter( 'size', $event)"
          :options="availableFilters.sizes.map(size => ({ id: size.size, text: size.size }))"
          v-cloak>
        </Select2>
      </div>

      <div v-if="availableFilters.withDate !== undefined && availableFilters.withDate" class="form-group">
        <DatePicker
          range
                    :model-value="range"
                    @update:model-value="updateRange"
                    :min-date="minDate"
                    :max-date="maxDate"
        >
        </DatePicker>
      </div>
      <button type="submit" class="btn btn-light ml-2 " v-if="Object.values(clientFilters).filter((f) => f !== null).length > 0" @click="resetFilters">
        <i class="fa fa-times" aria-hidden="true"></i>
        {{ $t('Reset') }}
      </button>
    </div>

    <div class="vl-parent mt-4">
      <loading :active="isLoading" color="#0275d8" :is-full-page="false" />
      <ProductsList
        :products="products"
        :prevent-product-click="preventProductClick"
        @click-product="onClickProductItem"
      >
        <template #product-item-footer="{product}">
          <slot name="product-item-footer" :product="product"></slot>
        </template>
      </ProductsList>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import ProductsList from "@/components/frontend/ProductsList.vue";
import qs from "qs";
import Select2 from "@/components/frontend/ui/Select2.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";
import dayjs from "dayjs";
import DatePicker from "@/components/frontend/ui/DatePicker.vue";
import pluralize from "pluralize";

export default defineComponent({
  name: "ProductsSearch",
  components: {
    Select2,
    DatePicker,
    Loading,
    ProductsList
  },
  props: {
    baseFilters: {
      type: Object,
      default: function() {
        return {};
      }
    },
    availableFilters: {
      type: Object,
      default: function() {
        return {};
      }
    },
    urlProducts: {
      required: true
    },
    minDate: {
      type: String,
    },
    maxDate: {
      type: String,
    },
    redirectOnSingleResult: {
      type: Boolean,
      default: false
    },
    preventProductClick: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: true,
      errors: {},
      products: {},
      filtersValues: {},
      clientFilters: {},
    };
  },
  computed: {
    minDateEnd() {
      let today = new Date(this.minDate);
      today.setUTCDate(today.getUTCDate() + 1);
      return today.toISOString().split('T')[0];
    },
    range() {
      return this.clientFilters.range ? this.clientFilters.range.split(':').map(date => new Date(date)) : null;
    },
  },
  methods: {
    resetFilters() {
      this.clientFilters = {};
      this.getResults();
    },
    updateRange(range) {
      if (range === null) {
        this.updateFilter("range", null);
        return;
      }
      this.updateFilter("range", range[0] && range[1] ? dayjs(range[0]).format('YYYY-MM-DD') + ':' + dayjs(range[1]).format('YYYY-MM-DD') : null);
    },
    updateFilter(filter, value) {
      this.clientFilters[filter] = value;
      this.getResults();
    },
    getResults(firstCall = false) {
      // push to history using window.location.replace
      window.history.pushState({}, "", "?" + new URLSearchParams(
        Object.entries(this.clientFilters).filter(([key, value]) => value !== "" && value !== null)
      ).toString());

      let filters = {};

      Object.entries(this.clientFilters).map(([key, value]) => {
        if (value === "" || value === null) {
          delete filters[key];
        }
        let filterKey = "filter[" + key + "]";
        filters[filterKey] = value;
      });

      Object.entries(this.baseFilters).map(([key, value]) => {
        const filterKey = "filter[" + key + "]";
        filters[filterKey] = value;
      });

      const params = new URLSearchParams(filters);
      this.isLoading = true;
      this.errors = {};
      axios.get(this.urlProducts + "&" + params.toString()).then(response => {
        this.products = response.data.data;

        console.log('redirection ? ',  this.redirectOnSingleResult)
        if (
          firstCall
          && this.redirectOnSingleResult
          && response.data.meta.total === 1
          && response.data.meta.redirectUrl !== null
        ) {
          window.location.href = response.data.meta.redirectUrl;
        }

      }).catch(error => {
        this.errors = Array.isArray(error.response.data.message) ? error.response.data.message : {error: [error.response.data.message]};

      }).finally(() => {
        this.isLoading = false;
      });
    },
    onClickProductItem(product) {
      this.$emit("click-product", product);
    }
  },
  mounted() {
    const parsed = qs.parse(window.location.search, { ignoreQueryPrefix: true });
    Object.entries(parsed)
      .filter(([key, value]) => {
        // check if the key is a filter using the availableFilters
        const backendFilters = Object.keys(this.availableFilters).map((k) => {
          // convert camelCase to snake_case and singularize to match the backend filters
          return pluralize.singular(k.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`))
        });
        return backendFilters.includes(key);
      })
      .forEach(([key, value]) => {
        this.clientFilters[key] = value;
      });
    Object.entries(this.baseFilters).map(filter => {
      this.filtersValues[filter[0]] = filter[1];
    });
    this.getResults(true);
  }
});
</script>


<style scoped>

</style>